import { render } from "./GiftCardReviews.vue?vue&type=template&id=137a7cb0&scoped=true"
import script from "./GiftCardReviews.vue?vue&type=script&lang=js"
export * from "./GiftCardReviews.vue?vue&type=script&lang=js"

import "./GiftCardReviews.vue?vue&type=style&index=0&id=137a7cb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137a7cb0"]])

export default __exports__